





































































import { Component, Vue, Prop } from 'vue-property-decorator'
@Component({
  name: 'capitalReceiptTable'
})
export default class CapitalReceiptTable extends Vue {
  @Prop({ default: () => {} }) public tableDetail: any
  // loading：
  public loadingForModuleTable: boolean = false
}
